import Vue from "vue";
import axios from "axios";
import Vuex from "vuex";
import builder from "xmlbuilder";

const GED = {
  namespaced: true,
  state: {
    guid: null,
  },
  actions: {
    sendDocumentElise(context, id) {
      return new Promise((resolve, reject) => {
        axios
          .postForm(window.urlapi + "document/elise/" + id, {})
          .then((response) => {
            console.log(response.data.data);
            resolve(true);
          });
      });
    },

  },
  mutations: {
    GETGUID: (state, guid) => {
      state.guid = guid;
    },
  },
  getters: {
    guid: (state) => {
      return state.guid;
    },
  },
  modules: {},
};

export default GED;
